import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  marketsByID: [],
  status: 'idle',
  error: null,
};

const marketsByIDSlice = createSlice({
  name: 'marketsByID',
  initialState,
  reducers: {
    setMarketsByID: (state, action) => {
      state.marketsByID = action.payload;
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setMarketsByID, setError, setLoading } =
  marketsByIDSlice.actions;
export default marketsByIDSlice.reducer;
